import {PartnerSlot} from '../partner-slot/partner-slot';
import {property} from '@polymer/lit-element';

class PartnerAd extends PartnerSlot {
    // Default value overrides
    @property({ type: String }) placement = 'inline_flex';

    _getDefaultSizes () {
        return [[300, 250]];
    }
}

customElements.define('partner-ad', PartnerAd);
